var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5147 6.01807C21.145 6.01807 19.8813 5.56432 18.8664 4.79885C17.7025 3.92135 16.8663 2.63416 16.571 1.15057C16.4978 0.784004 16.4585 0.405723 16.4547 0.0180664H12.5421V10.7093L12.5374 16.5654C12.5374 18.131 11.5178 19.4585 10.1046 19.9254C9.69441 20.0609 9.25144 20.1251 8.79019 20.0998C8.20144 20.0674 7.64972 19.8898 7.17019 19.6029C6.14972 18.9926 5.45784 17.8854 5.43909 16.6188C5.40956 14.6393 7.00987 13.0254 8.988 13.0254C9.37847 13.0254 9.75347 13.0892 10.1046 13.2049V10.2828V9.23229C9.73425 9.17744 9.35737 9.14885 8.97628 9.14885C6.81112 9.14885 4.78612 10.0488 3.33862 11.6703C2.24456 12.8956 1.58831 14.4588 1.48706 16.0981C1.3544 18.2515 2.14237 20.2985 3.6705 21.8088C3.89503 22.0306 4.13081 22.2363 4.37737 22.4262C5.68753 23.4345 7.28925 23.981 8.97628 23.981C9.35737 23.981 9.73425 23.9529 10.1046 23.8981C11.6805 23.6646 13.1346 22.9432 14.2821 21.8088C15.6921 20.4153 16.4711 18.5651 16.4796 16.5959L16.4594 7.85088C17.1321 8.36979 17.8675 8.79916 18.6569 9.13244C19.8846 9.65041 21.1863 9.91291 22.526 9.91244V7.07135V6.01713C22.5269 6.01807 22.5157 6.01807 22.5147 6.01807Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok_icon.c01982cfd81d5f495e7b0bd6b699c189.svg";
export { ForwardRef as ReactComponent };